<template>
  <div>
    <a-input
      :placeholder="placeholder"
      :value="displayValue"
      readonly
      @click="openBatchModal"
      allowClear
    />
    <BasicModal
      :title="title"
      @register="register"
      :bodyStyle="{ margin: '16px 16px 0' }"
      @ok="handleValues"
      @cancel="closeModal"
    >
      <a-textarea
        :placeholder="placeholder"
        v-model:value="inputValues"
        allowClear
        :rows="5"
        style="height: 240px"
      ></a-textarea>
    </BasicModal>
  </div>
</template>

<script lang="ts" setup>
  import { computed, ref } from 'vue'
  import { BasicModal, useModal } from 'framework/components/Modal'

  interface IProps {
    title?: string
    value: any
    placeholder?: string
  }

  const props = withDefaults(defineProps<IProps>(), {
    title: '批量输入',
    value: '',
    placeholder: '素材名称，多个请用【换行】隔开',
  })

  const emit = defineEmits(['update:value', 'change'])
  const inputValues = ref('')
  const [register, { openModal, closeModal }] = useModal()

  const normalizeValue = (value: unknown) => (value ?? '').toString()

  const displayValue = computed(() => {
    return normalizeValue(props.value).replace(/,/g, ' ')
  })

  function openBatchModal() {
    inputValues.value = normalizeValue(props.value).replace(/,/g, '\n')
    openModal()
  }

  function handleValues() {
    closeModal()
    const values = inputValues.value?.replace(/\n/g, ',')
    emit('update:value', values)
    emit('change', values)
  }
</script>
